import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';

import { routes } from '@/config/routes';

export function NotFoundPage() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="The page you're looking for doesn't exist."
      extra={
        <Link to={routes.home}>
          <Button type="primary">Go home</Button>
        </Link>
      }
    />
  );
}
